import XHR from "@/request/http";
import {
  composSun,
  computeMax,
  computeExpert,
  computeMachine,
} from "@/global/utils.js";
const $h = new XHR();
// url
const url = {
  lists: "/admin/v1/lesson/page",
  create: "/admin/v1/lesson/create", //新建
  update: "/admin/v1/lesson/update", //编辑评课视频
  del: "/admin/v1/lesson/del", //删除评课视频
  get: "/admin/v1/lesson/get", //获取
  portrait: "/admin/v1/lesson/portrait", //获取本次课程画像
  report: "/admin/v1/lesson/report", //获取评课报告
  reviewRecord: "/admin/v1/lesson/reviewRecord", //获取本地画像自己的打分
  review: "/admin/v1/lesson/review/create", //专家提交评课报告
  template: "/admin/v1/lesson/template", //获取本次评课模板信息
  recently: "/admin/v1/lesson/recently", //获取老师最近10次得分情况
  lesson_submit: "/admin/v1/lesson/review/submit", //提交评价
  lesson_start: "/admin/v1/lesson/review/start", //开始评课
  lesson_review: "/admin/v1/lesson/repeatReview", //重新评课
  lesson_repeat_ai_review: "/admin/v1/lesson/repeatAiReview", //重新机评
  lesson_chart: "/admin/v1/lesson/statistic",
  lesson_source: "/admin/v1/lesson/recommendResource", //教研资源推荐
  lesson_video: "/admin/v1/lesson/video/url", //获取腾讯云视频
  lesson_license: "/admin/v1/lesson/video/license", //
  lesson_video_count: "/admin/v1/lesson/video/count", //观看人数
  lesson_out_upload: "/admin/v1/file/url/upload",
  submit_feedback: "/admin/v1/lesson/submitFeedback", //提交评价
  audio_upload: "/admin/v1/file/audio/upload", //音频文件上传
};

//评课
export async function lists(data) {
  return await $h.request(url.lists, data, "GET");
}

//create
export async function create(data) {
  return $h.request(url.create, data, "POST");
}

//更新
export async function update(data) {
  return $h.request(url.update, data, "POST");
}

//删除
export async function del(data) {
  return $h.request(url.del, data, "POST");
}

export async function get(id) {
  return $h.request(url.get, { id: id }, "GET");
}
export async function template(id) {
  return $h.request(url.template, { lessonId: id }, "GET");
}

export async function report(id) {
  let res = await $h.request(url.report, { lessonId: id }, "GET");

  //表格数据
  let tableData = [];
  //雷达图数据
  let radarData = {};
  //柱状图数据
  let barData = {
    names: ["专家评价", "AI评价"],
    params: [],
    data: [[], []],
    max: [],
    diff_data: [[], []],
  };

  //二级指标类型时才判断（level=5 的“二级指标模版(新)”同为两级结构，复用此分支）
  if (res.data.templateLevel === 2 || res.data.templateLevel === 5) {
    // 遍历树形结构，将所有二级指标添加到tableData，并计算雷达数据
    if (res.data.indicatorList && Array.isArray(res.data.indicatorList)) {
      // 用于存储最终的三个数组
      const indicatorNames = [];
      const expertScores = [];
      const machineScores = [];
      const totalScores = [];
      const maxScores = [];

      res.data.indicatorList.forEach((parent) => {
        // 为每个一级指标计算二级指标的得分总和
        let parentExpertScore = 0;
        let parentMachineScore = 0;
        let parentScore = 0;
        let parentMaxScore = 0;

        indicatorNames.push(parent.name);

        if (parent.children && Array.isArray(parent.children)) {
          parent.children.forEach((child) => {
            tableData.push({
              ...child,
              parentName: parent.name || "", // 添加父级指标名称
              groupId: parent.id, //一级指标id
            });

            // 累加各二级指标的得分，并保留一位小数
            parentExpertScore =
              Math.round(
                (parentExpertScore + (Number(child.expertScore) || 0)) * 10
              ) / 10;
            parentMachineScore =
              Math.round(
                (parentMachineScore + (Number(child.machineScore) || 0)) * 10
              ) / 10;
            parentScore =
              Math.round((parentScore + (Number(child.score) || 0)) * 10) / 10;
            parentMaxScore =
              Math.round(
                (parentMaxScore + (Number(child.maxScore) || 0)) * 10
              ) / 10;

            //计算柱状图数据
            barData.params.push(child.name);
            let _machineScore = child.machineScore ? child.machineScore : 0;
            let _expertScore = child.expertScore ? child.expertScore : 0;
            let _maxScore = child.maxScore ? child.maxScore : 0;
            let _diffMachineScore =
              Math.ceil((_maxScore - _machineScore) * 10) / 10;
            let _diffExpertScore =
              Math.ceil((_maxScore - _expertScore) * 10) / 10;
            barData.data[0].push(_expertScore);
            barData.data[1].push(_machineScore);
            barData.max.push(_maxScore);
            barData.diff_data[0].push(_diffExpertScore);
            barData.diff_data[1].push(_diffMachineScore);
          });
        }

        // 将一级指标的累计得分添加到对应的数组中
        expertScores.push(parentExpertScore);
        machineScores.push(parentMachineScore);
        totalScores.push(parentScore);
        maxScores.push(parentMaxScore);
      });

      radarData = {
        indicatorNames,
        expertScores,
        machineScores,
        totalScores,
        maxScores,
      };
    }
  } else if (res.data.templateLevel === 3) {
    // 用于存储最终的三个数组
    const indicatorNames = [];
    const expertScores = [];
    const machineScores = [];
    const totalScores = [];
    const maxScores = [];
    if (res.data.indicatorList && Array.isArray(res.data.indicatorList)) {
      // 遍历一级指标
      res.data.indicatorList.forEach((firstLevelItem) => {
        // 遍历二级指标
        if (firstLevelItem.children && Array.isArray(firstLevelItem.children)) {
          firstLevelItem.children.forEach((secondLevelItem) => {
            indicatorNames.push(secondLevelItem.name);
            // 遍历三级指标
            if (
              secondLevelItem.children &&
              Array.isArray(secondLevelItem.children)
            ) {
              // 为每个一级指标计算二级指标的得分总和
              let parentExpertScore = 0;
              let parentMachineScore = 0;
              let parentScore = 0;
              let parentMaxScore = 0;
              secondLevelItem.children.forEach((thirdLevelItem) => {
                tableData.push({
                  ...thirdLevelItem,
                  parentName: secondLevelItem.name || "", // 添加父级指标名称（二级指标）
                  groupId: firstLevelItem.id, // 一级指标id
                  secondLevelId: secondLevelItem.id, // 二级指标id
                });

                // 累加各二级指标的得分，并保留一位小数
                parentExpertScore =
                  Math.round(
                    (parentExpertScore +
                      (Number(thirdLevelItem.expertScore) || 0)) *
                      10
                  ) / 10;
                parentMachineScore =
                  Math.round(
                    (parentMachineScore +
                      (Number(thirdLevelItem.machineScore) || 0)) *
                      10
                  ) / 10;
                parentScore =
                  Math.round(
                    (parentScore + (Number(thirdLevelItem.score) || 0)) * 10
                  ) / 10;
                parentMaxScore =
                  Math.round(
                    (parentMaxScore + (Number(thirdLevelItem.maxScore) || 0)) *
                      10
                  ) / 10;

                //计算柱状图数据
                barData.params.push(thirdLevelItem.name);
                let _machineScore = thirdLevelItem.machineScore
                  ? thirdLevelItem.machineScore
                  : 0;
                let _expertScore = thirdLevelItem.expertScore
                  ? thirdLevelItem.expertScore
                  : 0;
                let _maxScore = thirdLevelItem.maxScore
                  ? thirdLevelItem.maxScore
                  : 0;
                let _diffMachineScore =
                  Math.ceil((_maxScore - _machineScore) * 10) / 10;
                let _diffExpertScore =
                  Math.ceil((_maxScore - _expertScore) * 10) / 10;
                barData.data[0].push(_expertScore);
                barData.data[1].push(_machineScore);
                barData.max.push(_maxScore);
                barData.diff_data[0].push(_diffExpertScore);
                barData.diff_data[1].push(_diffMachineScore);
              });

              // 将一级指标的累计得分添加到对应的数组中
              expertScores.push(parentExpertScore);
              machineScores.push(parentMachineScore);
              totalScores.push(parentScore);
              maxScores.push(parentMaxScore);
            }
          });
        }
      });
    }

    radarData = {
      indicatorNames,
      expertScores,
      machineScores,
      totalScores,
      maxScores,
    };
  }

  console.log("barData is ", barData);

  return {
    ...res.data,
    tableData,
    radarData,
    barData,
  };
}

export async function portrait(id) {
  let res = await $h.request(url.portrait, { lessonId: id }, "GET");
  let data = res.data;
  let lesson = data.lesson;
  let expert = data.rules; //专家评价
  let machine = data.rules; //AI评价
  let finalScore = data.finalScore; // 总得分
  let complexRules = data.complexRules; // 综合得分(人机)
  let expertRules = data.rules; // 专家打分
  let machineRules = data.rules; //机器打分
  let logs = data.logs; //视频过程记录
  let arr = []; // 列表
  let leida = [];
  let leida2 = {
    title: [],
    max: [],
    machine: [],
    expert: [],
    complex: [],
    indicator: [],
  };
  data.rules.forEach((item) => {
    let obj = {
      name: item.groupName,
      expert: 0, //专家评价
      machine: 0, //AI评价
      complex: 0, //综合
      max: 0, //最大分
    };
    item.children &&
      item.children.forEach((itx) => {
        obj.expert =
          Math.floor((obj.expert + (itx.expertScore || 0)) * 10) / 10;
        obj.machine =
          Math.floor((obj.machine + (itx.machineScore || 0)) * 10) / 10;
        obj.complex = Math.floor((obj.complex + (itx.score || 0)) * 10) / 10;
        obj.max = Math.floor((obj.max + (itx.maxScore || 0)) * 10) / 10;
      });
    leida.push(obj);
  });

  leida.forEach((item) => {
    leida2.title.push(item.name);
    leida2.expert.push(item.expert);
    leida2.machine.push(item.machine);
    leida2.complex.push(item.complex);
    leida2.max.push(item.max);
    leida2.indicator.push({ name: item.name, max: item.max });
  });
  // if(expert) {
  //     arr.push({
  //         name:"专家评价",
  //         itemStyle: {
  //             color: '#E53B00'
  //         },
  //         children:computeExpert(expert)
  //     })
  //     expert.forEach(item=>{
  //         item.children.forEach(itx=>{
  //             itx['max'] =  computeMax(itx.maxScore,itx.score)
  //         })
  //     })
  // }

  // if(machine){
  //     arr.push({
  //         name:"AI评价",
  //         itemStyle: {
  //             color: '#0052DA'
  //         },
  //         children:computeMachine(machine)
  //     })
  // }
  if (data.rules) {
    arr.push({
      name: "综合得分",
      itemStyle: {
        color: "#0052DA",
      },
      children: composSun(data.rules),
    });
  }
  // console.log(composSun(data.rules))

  //计算星星
  complexRules &&
    complexRules.forEach((item) => {
      item.children.forEach((itx) => {
        itx["max"] = computeMax(itx.maxScore, itx.score);
      });
    });

  //指标人机柱状图对比
  let rule_obj = {
    names: ["专家评价", "AI评价"],
    params: [],
    data: [[], []],
    max: [],
    diff_data: [[], []],
    // params:['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    // data:[[2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],[6.0, 5.9, 7.0, 21.2, 21.6, 71.7, 131.6, 161.2, 31.6, 21.0, 1.4, 5.3]]
  };

  //指标集合
  let rule = [];

  data.rules.forEach((item) => {
    item.children.forEach((itx) => {
      itx.groupId = item.id;
      itx.feedbackScore = itx.feedbackScore !== null ? itx.feedbackScore : 0;
      itx.parentName = item.groupName;
      rule.push(itx);
      rule_obj.params.push(itx.name);
      let _machineScore = itx.machineScore ? itx.machineScore : 0;
      let _expertScore = itx.expertScore ? itx.expertScore : 0;
      let _maxScore = itx.maxScore ? itx.maxScore : 0;
      let _diffMachineScore = Math.ceil((_maxScore - _machineScore) * 10) / 10;
      let _diffExpertScore = Math.ceil((_maxScore - _expertScore) * 10) / 10;
      rule_obj.data[0].push(_expertScore);
      rule_obj.data[1].push(_machineScore);
      rule_obj.max.push(_maxScore);
      rule_obj.diff_data[0].push(_diffExpertScore);
      rule_obj.diff_data[1].push(_diffMachineScore);
    });
  });

  let teacher_name = data.lesson.teacherName;

  return {
    res,
    expert,
    machine,
    finalScore,
    arr,
    complexRules,
    logs,
    expertRules,
    machineRules,
    rule_obj,
    rule,
    leida,
    leida2,
    teacher_name,
    lesson,
  };
}

export async function reviewRecord(lesson_id) {
  let res = await $h.request(url.reviewRecord, { lessonId: lesson_id }, "GET");
  let data = res.data;
  let rules = (data && data.rules) || [];
  let logs = (data && data.logs) || []; //视频过程记录
  //计算星星
  rules &&
    rules.forEach((item) => {
      item.children.forEach((itx) => {
        itx["max"] = computeMax(itx.maxScore, itx.score);
      });
    });
  return {
    res,
    data,
    logs,
    rules,
  };
}

//
export async function recently(id) {
  return $h.request(url.recently, { teacherId: id }, "GET");
}

export async function lesson_submit(data) {
  return $h.request(url.lesson_submit, data, "POST");
}

export async function lesson_start(id) {
  return $h.request(url.lesson_start, { lessonId: id }, "POST");
}

export async function lesson_review(id) {
  return $h.request(url.lesson_review, { lessonId: id }, "POST");
}

export async function lesson_repeat_ai_review(id) {
  return $h.request(url.lesson_repeat_ai_review, { lessonId: id }, "POST");
}
//教研资源推荐
export async function lesson_source(id) {
  return $h.request(url.lesson_source, { lessonId: id }, "GET");
}

export async function lesson_chart(id) {
  let res = await $h.request(url.lesson_chart, { lessonId: id }, "GET");

  let radar_data = [];
  let indicator_data = [];
  let group_name_lists = [];
  let arr = [];
  if (res.code == 0) {
    let data = res.data.list;

    data.forEach((item) => {
      radar_data.push(item.finalScore);
      indicator_data.push({
        name: item.groupName,
        max: item.maxScore,
      });
      group_name_lists.push(item.groupName);
      let obj = {
        product: item.groupName,
        AI评价: item.machineScore,
        专家评: item.expertScore,
        最终评分: item.finalScore,
      };
      arr.push(obj);
    });
  }

  return {
    res,
    arr,
    radar_data,
    indicator_data,
    group_name_lists,
  };
}

export async function lesson_video(lesson_id) {
  return $h.request(url.lesson_video, { lessonId: lesson_id }, "GET");
}

export async function lesson_license() {
  return $h.request(url.lesson_license, "GET");
}

export async function lesson_video_count(lesson_id) {
  return $h.request(url.lesson_video_count, { lessonId: lesson_id }, "GET");
}

export function lesson_out_upload(videoUrl) {
  return $h.postStream(url.lesson_out_upload, { videoUrl: videoUrl });
}

export function submit_feedback(data) {
  return $h.request(url.submit_feedback, data, "POST");
}

//音频文件上传
export function audio_upload(payload, onProgress) {
  const formData = new FormData();
  formData.append("file", payload.file);
  if (payload.templateId !== undefined && payload.templateId !== null && payload.templateId !== "") {
    formData.append("templateId", payload.templateId);
  }
  if (payload.externalId) formData.append("externalId", payload.externalId);
  if (payload.teacherId) formData.append("teacherId", payload.teacherId);
  if (payload.subjectId) formData.append("subjectId", payload.subjectId);
  if (payload.title) formData.append("title", payload.title);
  if (payload.className) formData.append("className", payload.className);
  if (payload.courseName) formData.append("courseName", payload.courseName);
  return $h.postForm(url.audio_upload, formData, onProgress);
}
